import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.SET_CURRENT_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/setCurrentTrigger.js